/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "129e48886266777ff1eb184747b25cc6275171fe";
